import { ErrorType, ExtendedAxiosError } from '@common/fetch/types';

import { locale } from './locale';

export const getErrorMessage = (error: ExtendedAxiosError<ErrorType>) =>
  error?.response?.data?.error ?? error?.response?.data?.title ?? error?.response?.data?.message ?? locale.common_error;
